import {lazy} from '@aboutyou/lazy-imports';

export const PageReadyHint = lazy(() =>
  import('./PageReadyHint.eager').then(mod => ({
    default: mod.PageReadyHint,
  })),
);
